<template>
<div class="camera" id="camera" align="center">
<br>
<br>
<br>
<br>
<video autoplay class="feed"></video>
<br>
<button class="btn btn-lg btn-primary" id="button" align="center" data-toggle="button" v-on:click="$emit('takePicture')"> <i class="fa fa-camera" aria-hidden="true"></i><br> Scatta</button>
<canvas ref="canvas" id="canvas" width="640" height="480" style="display:none;"></canvas>
        
</div>
</template>

<script>
export default {
name: "camera",

methods:  {
  init ()  {
    if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
    let constraints = { 
           video: { 
             width: {
               min: 300,
               ideal: 1280,
               max: 400
               },
               height: {
                 min: 300,
                 ideal: 720,
                 max: 400
                  }
               }
               };
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        const videoPlayer = document.querySelector("video");
        videoPlayer.srcObject = stream;
        videoPlayer.play();
      });
    }else  {
      alert("Cannote get Media Devices"); 
}
}
},
beforeMount () {
  this.init();
}
}

</script>

<style lang="scss" scoped>
.camera {
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
 

  .feed {
    display: block;
    width: 100%;
    
    margin: 0 auto;
    
    background-color: #171717;
    box-shadow: 4px 4px 6px 0px rgba(0,0,0,0.35);
}


button#button {
    SIZE: A5;
    FONT-WEIGHT: 100;
    padding: 15px;
    font-size: 15px;
    line-height: 1.5;
    border-radius: 15px;
   
}



.snap {
display: block;
width: 75px;
height: 75px;
border-radius: 50%;

margin: 25px auto;

background-color: transparentize($color: #007fff, $amount: 0.5);
border: 1px solid #171717;
outline:navajowhite;

cursor: pointer;

&:hover {
background-color: #007fff;
}
&:active {
background-color:darken($color: #007fff,$amount: 10)
}
}
}
</style>